import { API, Endpoints, Team } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import { getCorrectNameFromNumber } from "shared/helpers/utils/getCorrectNameFormNumber";
import { useTheme } from "styled-components";

export const ChannelDefault: FC<{ channel?: Team<'Local'>}> = ({ channel }) => {
    const { t, i18n: {language} } = useTranslation();
    const profile = useProfile();
    const theme = useTheme();
    const [isDefault, setIsDefault] = useState(false);
        //@ts-ignore
    const currentTeam = useSelector((state) => state?.organizations)?.team;

    const channelProjectsCount = useMemo(() => {
    return currentTeam?.tabs?.reduce((sum: number, item: any) => sum + (item?.filter?.projectIds?.length || 0), 0) || 0;
    }, [currentTeam])
    const participantsCount = useMemo(() => {
    return currentTeam?.membersIDs?.length || 0
    }, [])
    const channelInfoString = useMemo(() => {
    let string = ''
    string += channelProjectsCount || 0
    string += ' ' + getCorrectNameFromNumber(channelProjectsCount || 0, [t('subscription.projects_1'), t('subscription.projects_2'), t('subscription.projects_3')])
    return string
    }, [t, channelProjectsCount, participantsCount])

    const defaultChannelId = useMemo(() => {
        //@ts-ignore
        return profile && profile?.defaultEduChannelId
    } , [profile])

    const onSetChannelDefault = async (flag: boolean) => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Designer/UpdateDefaultEduChannel')
        .body(flag ? currentTeam.teamId : '')
        .post()
        .send()
        .then((r) => {
            if (r.status === 200) {
                setIsDefault(flag)
            }
        })
    }

    useEffect(() => {
        if (defaultChannelId === currentTeam.teamId) {
            setIsDefault(true)
        }
    } , [defaultChannelId, currentTeam])
    
    const checkbox = useMemo(() => {
        return (
            <MagicBoxRow
                label={t('teams.adminPage.default_mediiia')}
                checked={isDefault}
                
                style={{color: theme.inputs.disabledColor, marginLeft: 24 }}
                onClick={() => onSetChannelDefault(!isDefault)}
            />
        )
    } , [isDefault, language])
    
    return (
        <FlexBox gx={24} direction="row" offsetTop={4}>
            {channelInfoString}
            {checkbox}
        </FlexBox>
    )
}import { API, Endpoints, Team } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import { getCorrectNameFromNumber } from "shared/helpers/utils/getCorrectNameFormNumber";
import { useTheme } from "styled-components";

export const ChannelDefault: FC<{ channel?: Team<'Local'>}> = ({ channel }) => {
    const { t, i18n: {language} } = useTranslation();
    const profile = useProfile();
    const theme = useTheme();
    const [isDefault, setIsDefault] = useState(false);
        //@ts-ignore
    const currentTeam = useSelector((state) => state?.organizations)?.team;

    const channelProjectsCount = useMemo(() => {
    return currentTeam?.tabs?.reduce((sum: number, item: any) => sum + (item?.filter?.projectIds?.length || 0), 0) || 0;
    }, [currentTeam])
    const participantsCount = useMemo(() => {
    return currentTeam?.membersIDs?.length || 0
    }, [])
    const channelInfoString = useMemo(() => {
    let string = ''
    string += channelProjectsCount || 0
    string += ' ' + getCorrectNameFromNumber(channelProjectsCount || 0, [t('subscription.projects_1'), t('subscription.projects_2'), t('subscription.projects_3')])
    return string
    }, [t, channelProjectsCount, participantsCount])

    const defaultChannelId = useMemo(() => {
        //@ts-ignore
        return profile && profile?.defaultEduChannelId
    } , [profile])

    const onSetChannelDefault = async (flag: boolean) => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Designer/UpdateDefaultEduChannel')
        .body(flag ? currentTeam.teamId : '')
        .post()
        .send()
        .then((r) => {
            if (r.status === 200) {
                setIsDefault(flag)
            }
        })
    }

    useEffect(() => {
        if (defaultChannelId === currentTeam.teamId) {
            setIsDefault(true)
        }
    } , [defaultChannelId, currentTeam])
    
    const checkbox = useMemo(() => {
        return (
            <MagicBoxRow
                label={t('teams.adminPage.default_mediiia')}
                checked={isDefault}
                
                style={{color: theme.inputs.disabledColor, marginLeft: 24 }}
                onClick={() => onSetChannelDefault(!isDefault)}
            />
        )
    } , [isDefault, language])
    
    return (
        <FlexBox gx={24} direction="row" offsetTop={4}>
            {channelInfoString}
            {checkbox}
        </FlexBox>
    )
}